import { config } from '_appConfig'

export const throwLocal = (message: string) => {
  if (config.default.environment === 'local') {
    throw new Error(message)
  }

  console.error(message)
}
